'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import PlanBody from '@/ui/segments/plans/body';
import PlanHeader from '@/ui/segments/plans/header';
import { cn } from '@/utils/css-class';
import type { PlanV2 } from '@/types/virtual-lab/pricing';
export function PlanCard(t0) {
  const $ = _c(17);
  const {
    plan,
    isCurrentTier,
    className,
    hideContactButton,
    testId
  } = t0;
  const [billingInterval, setBillingInterval] = useState("month");
  const t1 = isCurrentTier ? "border-primary-7 bg-bg-white text-primary-9" : "border-neutral-2 bg-white";
  let t2;
  if ($[0] !== className || $[1] !== t1) {
    t2 = cn("relative w-full rounded-xl border p-6", t1, className);
    $[0] = className;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== billingInterval || $[4] !== hideContactButton || $[5] !== isCurrentTier || $[6] !== plan || $[7] !== testId) {
    t3 = <PlanHeader plan={plan} billingInterval={billingInterval} setBillingInterval={setBillingInterval} isCurrentTier={isCurrentTier} hideContactButton={hideContactButton} testId={testId} />;
    $[3] = billingInterval;
    $[4] = hideContactButton;
    $[5] = isCurrentTier;
    $[6] = plan;
    $[7] = testId;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== isCurrentTier || $[10] !== plan) {
    t4 = <PlanBody plan={plan} isCurrentTier={isCurrentTier} />;
    $[9] = isCurrentTier;
    $[10] = plan;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t2 || $[13] !== t3 || $[14] !== t4 || $[15] !== testId) {
    t5 = <div className={t2} data-testid={testId}>{t3}{t4}</div>;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = testId;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
}